import React from 'react';
import { Link } from "react-router-dom";
import ListItemTitle from '../../shared/ListItemTitle';
import { recipeDeleteService } from '../../services/recipeDeleteService';
import { POPUP_KEY_DELETE_RECIPE } from '../../constant';
import DeleteItemIcon from '../../shared/DeleteItemIcon';
import EditItemIcon from '../../shared/EditItemIcon';
import { MAIN_RECIPE_ELEMENTS } from '../helper';
import { recipeNameService } from "../../services/recipeNameService";

const RecipeListItem = ({recipeId, recipe}) => {
    return (
        <>
            <ListItemTitle itemCode={recipe} itemService={recipeNameService}/>
            <p className="main__subtitle recipe__list-content">{recipe.recipeType}</p>
            <div className="recipe__list-icons">
                <Link to={`/recipe/item/${recipeId}/?ingredientTab=${MAIN_RECIPE_ELEMENTS}`}>
                    <EditItemIcon />
                </Link>
                <DeleteItemIcon 
                    itemId={recipeId} 
                    itemDeleteService={recipeDeleteService} 
                    popupKey={POPUP_KEY_DELETE_RECIPE} 
                />
            </div>
        </>
    );
};

export default RecipeListItem;
